<!-- NOTE:  Bootstrap dropdownが使われている https://cccabinet.jpn.org/bootstrap4/components/dropdowns -->
<template>
  <div class="advices-index__content-search-item">
    <button class="advices-index__content-search-item-btn dropdown-toggle"
            type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{ selected_year }}
    </button>

    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <!-- NOTE: プルダウンを2018年から表示する(year_countは表示するプルダウンの個数) -->
      <a v-for='n in year_count' :key='n' class="dropdown-item"
         :href="`/clinic/advices?year=${ 2017 + n }`">
        {{ 2017 + n }}年
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected_year: Number,
    year_count: Number,
  }
}
</script>

<style scoped>
</style>
